import { useCallback, useEffect, useState } from 'react'
import { useStreetsQuery } from '../../../../api/options/hooks'
import { Step3FormProps, Step3FormStreetProps } from '../types'

const useStep3FormStreet = (form: Step3FormProps['form']): Step3FormStreetProps => {
    const city = form.watch('invoiceAddressCity')
    const zip = form.watch('invoiceAddressZIP')
    const street = form.watch('invoiceAddressCity')
    const [streetSearch, setStreetSearch] = useState<string | undefined>(street)
    const handleStreetSearchChanged = useCallback((s: string) => setStreetSearch(s), [])
    useEffect(() => {
        setStreetSearch(street)
    }, [street])

    const { data, isLoading } = useStreetsQuery(streetSearch, city, zip)

    return {
        streetSearch,
        handleStreetSearchChanged,
        streets: data || [],
        isLoading,
    }
}

export default useStep3FormStreet
